import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Microphone.svg",
  "use": "Microphone.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Microphone.svg\"><path d=\"M17.0209,27.0209a2,2,0,0,1,4,0v6a11,11,0,0,0,22,0v-6a2,2,0,0,1,4,0v6a15.0107,15.0107,0,0,1-13,14.8507v4.1493h6a2,2,0,1,1,0,4h-16a2,2,0,0,1,0-4h6V47.8716a15.0109,15.0109,0,0,1-13-14.8507Zm22-12v18a7,7,0,0,1-14,0v-18a7,7,0,1,1,14,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol